var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeatBusiness({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-bbox": "20 20 160 160",
    viewBox: "20 20 160 160",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    "aria-hidden": "true",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.145 50.769h-16.29A9.231 9.231 0 0 0 82.624 60l-.003 22.622L60 82.624a9.231 9.231 0 0 0-9.231 9.231v16.29A9.231 9.231 0 0 0 60 117.376h22.622L82.624 140a9.231 9.231 0 0 0 9.231 9.231h16.29a9.231 9.231 0 0 0 9.231-9.231v-22.625h22.625a9.231 9.231 0 0 0 9.231-9.231v-16.29a9.231 9.231 0 0 0-9.231-9.231l-22.625-.003V59.998c0-5.096-4.133-9.229-9.231-9.229zM100 20c44.183 0 80 35.817 80 80s-35.817 80-80 80-80-35.817-80-80 35.817-80 80-80z",
    "data-color": 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatBusiness);
export default __webpack_public_path__ + "static/media/repeat_business.59e29d7d7b92cab096f7d47b9a9a7f11.svg";
export { ForwardRef as ReactComponent };